<template>
  <img v-if="signature" v-bind:src="'data:image/jpg;base64,' + signature" alt="Handtekening">
</template>

<script>
import { startWith, switchMap } from "rxjs/operators";
import { getUserSignature } from "@/services";

export default {
  name: 'PrescriberSignature',
  props: {
    userId: Number
  },
  subscriptions () {
    return {
      signature: this.$watchAsObservable(() => this.userId).pipe(
        startWith({newValue: this.userId}),
        switchMap(value => getUserSignature(value.newValue))
      )
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
